import {
  fetchEntryComments,
  fetchEntryCommentCounts,
  createEntryComment,
  updateEntryComment,
  resolveEntryComment,
  deleteEntryComment,
} from "../api/api";

export const getComments = (workspaceId, entryId, filter = 'all', fieldId) => async (dispatch) => {
  dispatch({ type: 'COMMENTS_LOADING' });
  try {
    const params = { filter };
    if (fieldId) params.fieldId = fieldId;
    const res = await fetchEntryComments(workspaceId, entryId, params);
    dispatch({
      type: 'GET_COMMENTS',
      payload: res.data.comments || [],
    });
  } catch (err) {
    console.error("Error fetching comments", err);
    dispatch({ type: 'COMMENT_ERROR', payload: err.response?.data?.message || 'Failed to load comments' });
  }
};

export const getCommentCounts = (workspaceId, entryId) => async (dispatch) => {
  try {
    const res = await fetchEntryCommentCounts(workspaceId, entryId);
    dispatch({
      type: 'SET_COMMENT_COUNTS',
      payload: res.data.counts || { entry: 0, byField: {} },
    });
  } catch (err) {
    console.error("Error fetching comment counts", err);
  }
};

export const addComment = (workspaceId, entryId, data) => async (dispatch) => {
  try {
    const res = await createEntryComment(workspaceId, entryId, data);
    return res.data;
  } catch (err) {
    console.error("Error creating comment", err);
    return err.response?.data || { status: 'error', message: 'Failed to create comment' };
  }
};

export const editComment = (commentId, body) => async (dispatch) => {
  try {
    const res = await updateEntryComment(commentId, { body });
    return res.data;
  } catch (err) {
    console.error("Error updating comment", err);
    return err.response?.data || { status: 'error', message: 'Failed to update comment' };
  }
};

export const toggleResolveComment = (commentId, resolved) => async (dispatch) => {
  try {
    const res = await resolveEntryComment(commentId, resolved);
    return res.data;
  } catch (err) {
    console.error("Error resolving comment", err);
    return err.response?.data || { status: 'error', message: 'Failed to resolve comment' };
  }
};

export const removeComment = (commentId) => async (dispatch) => {
  try {
    const res = await deleteEntryComment(commentId);
    return res.data;
  } catch (err) {
    console.error("Error deleting comment", err);
    return err.response?.data || { status: 'error', message: 'Failed to delete comment' };
  }
};

export const clearComments = () => ({ type: 'CLEAR_COMMENTS' });
